import { IImage } from '~/types/model.types';
import { TCloudinaryUploadResponse } from '~/types/server.types';
import { TFileToUpload } from '~/types/file-upload.types';
import { ImageAdapter } from '~/services/adapters/image.adapter';

export class ImageService extends ImageAdapter {
    private translateCloudinaryResponseToImageInterface({
        secure_url,
        public_id,
        original_filename,
        bytes,
        width,
        height,
        phash
    }: TCloudinaryUploadResponse) {
        const image: IImage = {
            url: secure_url,
            cloudinary_url: secure_url,
            cloudinary_public_id: public_id,
            filename: original_filename,
            filesize: bytes,
            filetype: 'image/png',
            cloudinary_sub_account: 'honeybook',
            width: width,
            height: height,
            phash: phash
        };
        return image;
    }

    async uploadImage({
        file,
        folder,
        setUploadProgress,
        cloudinary_public_id
    }: {
        file: TFileToUpload | string;
        folder?: string;
        setUploadProgress?: (progress: number, file: TFileToUpload) => void;
        cloudinary_public_id?: string;
    }) {
        const onUploadProgress = ({ loaded, total }) => {
            if (!setUploadProgress) {
                return;
            }

            let progress = (loaded / total) * 100;
            // uploading to cloudinary is roughly 99 percent of the total process
            // (the other 1% is a call to our api to add the file to the user assets)
            progress *= 0.99;
            setUploadProgress(progress, file as TFileToUpload);
        };
        const uploadImageToCloudinaryResponse = await this.uploadToCloudinary(
            file,
            folder,
            onUploadProgress,
            cloudinary_public_id
        );

        return this.translateCloudinaryResponseToImageInterface(
            uploadImageToCloudinaryResponse
        );
    }
}
